var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"column"},[_c('LogoLink')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }